import { lazy } from 'react';
import { MercureProvider } from '@lingoda/event-source';
import { EventSourceNotificationsListener } from '@lingoda/notifications';
import { isOnboardingChecklistEnabled } from '@lingoda/feature-flags';
import { Suspense } from '@lingoda/ui';
import { mercureClient } from '../../../../utils/mercure-event-source';
import type { PropsWithChildren } from 'react';

const AchievementEventManager = lazy(() => import('./AchievementEventManager'));

export const EventSourceListener = ({ children }: PropsWithChildren<unknown>) => {
    return (
        <MercureProvider client={mercureClient}>
            <Suspense>
                {isOnboardingChecklistEnabled() && <AchievementEventManager />}
                <EventSourceNotificationsListener />
                {children}
            </Suspense>
        </MercureProvider>
    );
};
